module.exports = __webpack_public_path__ + "img/any.747dae3d.png";